import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export const DrawerActions = ({ children }) => {
    return (_jsx(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            mt: 6,
            p: 4,
        }, children: children }));
};
